import axios from 'axios';

export default {
  state: {
    mainPageData: null,
    loading: false,
    error: null,
    loaded: false
  },
  mutations: {
    SET_MAIN_PAGE_DATA(state, data) {
      state.mainPageData = data;
      state.loaded = true;
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    RESET_LOADED_STATE(state) {
      state.loaded = false;
    }
  },
  actions: {
    async fetchMainPageData({ commit, state, rootState }, update=false) {
      // Skip fetching if data is already loaded
      if (!update && state.loaded && state.mainPageData) {
        //return;
      }

      try {
        commit('SET_LOADING', true);
        const response = await axios.get('/api/mainpage/', {params: {gender: rootState.gender.gender}});

        if (response.data && response.data.data) {
          commit('SET_MAIN_PAGE_DATA', response.data.data);
        } else {
          throw new Error('Invalid data format received from API');
        }

        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message || 'Ошибка при загрузке данных главной страницы');
        console.error('Error fetching main page data:', error);
      } finally {
        commit('SET_LOADING', false);
      }
    },

    // Force refresh method (optional) if you need to manually refresh the data
    async refreshMainPageData({ commit, dispatch }) {
      commit('SET_LOADING', true);
      commit('SET_MAIN_PAGE_DATA', null);
      commit('SET_ERROR', null);
      commit('RESET_LOADED_STATE');
      await dispatch('fetchMainPageData');
    }
  },
  getters: {
    mainPageData: state => state.mainPageData,
    mainPageLoading: state => state.loading,
    mainPageError: state => state.error,
    mainPageLoaded: state => state.loaded
  }
}
